// extracted by mini-css-extract-plugin
module.exports = {"like":"_2Jgb9","liked":"_2Mx7M","not-clickable":"_7k_jX","notClickable":"_7k_jX","like-button":"_3N_5d","likeButton":"_3N_5d","likes":"_1H4bD"};